/* Cargo Butler Fitment Configurator
   Requires: window.CB_VEHICLES (loaded from cb-vehicles-data.js)
   Phase 2: supports URL params ?truck=<slug>&bed=<slug> for QR-code microsite use.
*/
(function() {
  'use strict';

  /* CONSTANTS */
  var ROW_LENGTH_MM = { 4: 1518, 5: 1893, 6: 2268 };
  var SAFETY_MM = 4;
  var KIT_VARIANTS = {
    4: { name: 'Short Bed Kit',    sku: 'CB-SHORT-01', price: 179.95, variantId: 53331443482937 },
    5: { name: 'Standard Bed Kit', sku: 'CB-STD-01',   price: 219.95, variantId: 53352539455801 },
    6: { name: 'Long Bed Kit',     sku: 'CB-LONG-01',  price: 259.95, variantId: 53352539488569 }
  };

  /* DOM REFS */
  var $type   = document.getElementById('cb-type');
  var $brand  = document.getElementById('cb-brand');
  var $model  = document.getElementById('cb-model');
  var $bed    = document.getElementById('cb-bed');
  var $result = document.getElementById('cb-result');
  var $cta    = document.getElementById('cb-cta');
  if (!$type || !window.CB_VEHICLES) return;

  /* BUILD INDEX: type -> brand -> model -> [vehicle entries] */
  var idx = {};
  window.CB_VEHICLES.forEach(function(v) {
    idx[v.type] = idx[v.type] || {};
    idx[v.type][v.brand] = idx[v.type][v.brand] || {};
    idx[v.type][v.brand][v.model] = idx[v.type][v.brand][v.model] || [];
    idx[v.type][v.brand][v.model].push(v);
  });

  /* HELPERS */
  function slugify(s) {
    return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function fillSelect(sel, options, placeholder) {
    sel.innerHTML = '';
    if (placeholder) {
      var opt = document.createElement('option');
      opt.value = ''; opt.textContent = placeholder; opt.disabled = true; opt.selected = true;
      sel.appendChild(opt);
    }
    options.forEach(function(o) {
      var opt = document.createElement('option');
      opt.value = o.value; opt.textContent = o.label;
      if (o.selected) opt.selected = true;
      sel.appendChild(opt);
    });
    sel.disabled = options.length === 0;
  }
  function recommendKit(bedLengthMM) {
    if (bedLengthMM >= ROW_LENGTH_MM[6] + SAFETY_MM) return { rows: 6, fits: true };
    if (bedLengthMM >= ROW_LENGTH_MM[5] + SAFETY_MM) return { rows: 5, fits: true };
    if (bedLengthMM >= ROW_LENGTH_MM[4] + SAFETY_MM) return { rows: 4, fits: true };
    return { rows: 0, fits: false };
  }
  function coveragePct(bedLengthMM, rows) {
    return rows > 0 ? (ROW_LENGTH_MM[rows] / bedLengthMM * 100) : 0;
  }
  function coverageGapMM(bedLengthMM, rows) {
    return rows > 0 ? Math.max(0, bedLengthMM - ROW_LENGTH_MM[rows]) : 0;
  }
  function escapeHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function readUrlParams() {
    var p = {};
    try {
      var qs = (window.location.search || '').replace(/^\?/, '');
      qs.split('&').forEach(function(pair) {
        if (!pair) return;
        var kv = pair.split('=');
        p[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1] || '');
      });
    } catch (e) {}
    return p;
  }

  /* POPULATE DROPDOWNS */
  function populateBrands(preselectBrand) {
    var type = $type.value;
    if (!idx[type]) { fillSelect($brand, [], 'Select brand'); fillSelect($model, [], 'Select model'); fillSelect($bed, [], 'Select bed'); clearResult(); return; }
    var brands = Object.keys(idx[type]).sort().map(function(b) { return { value: b, label: b, selected: preselectBrand && slugify(b) === slugify(preselectBrand) }; });
    fillSelect($brand, brands, 'Select brand');
    if (preselectBrand && $brand.value) populateModels();
    else { fillSelect($model, [], 'Select model'); fillSelect($bed, [], 'Select bed'); clearResult(); }
  }
  function populateModels(preselectModel) {
    var type = $type.value, brand = $brand.value;
    if (!brand || !idx[type] || !idx[type][brand]) { fillSelect($model, [], 'Select model'); fillSelect($bed, [], 'Select bed'); clearResult(); return; }
    var models = Object.keys(idx[type][brand]).sort().map(function(m) { return { value: m, label: m, selected: preselectModel && slugify(m) === slugify(preselectModel) }; });
    fillSelect($model, models, 'Select model');
    if (preselectModel && $model.value) populateBeds();
    else { fillSelect($bed, [], 'Select bed'); clearResult(); }
  }
  function populateBeds(preselectBed) {
    var type = $type.value, brand = $brand.value, model = $model.value;
    if (!model || !idx[type] || !idx[type][brand] || !idx[type][brand][model]) { fillSelect($bed, [], 'Select bed'); clearResult(); return; }
    var beds = idx[type][brand][model].map(function(v) {
      var inches = (v.len / 25.4).toFixed(1);
      return { value: v.bed, label: v.bed + ' (' + inches + '")', selected: preselectBed && slugify(v.bed) === slugify(preselectBed) };
    });
    fillSelect($bed, beds, 'Select bed');
    if (preselectBed && $bed.value) renderResult();
    else clearResult();
  }
  function clearResult() { $result.innerHTML = ''; $cta.innerHTML = ''; }

  /* RENDER RESULT */
  function renderResult() {
    var type = $type.value, brand = $brand.value, model = $model.value, bedVal = $bed.value;
    if (!type || !brand || !model || !bedVal) return clearResult();
    var vehicle = idx[type][brand][model].find(function(v) { return v.bed === bedVal; });
    if (!vehicle) return clearResult();

    var rec = recommendKit(vehicle.len);
    if (!rec.fits) {
      $result.innerHTML =
        '<div class="cb-result__card cb-result__card--bad">' +
          '<p class="cb-result__eyebrow">Heads up</p>' +
          '<h3>Compact Bed Kit — coming soon</h3>' +
          '<p>Your bed is ' + vehicle.len + ' mm (' + (vehicle.len/25.4).toFixed(1) + '") — smaller than our current minimum (1,518 mm).</p>' +
          '<p>We’re launching a Compact Bed Kit for Maverick, Ranger 5′, Santa Cruz, Rivian R1T, and Frontier 5′ buyers. <a href="/pages/notify-me?model=' + encodeURIComponent(model) + '">Leave your email to be notified</a>.</p>' +
        '</div>';
      $cta.innerHTML = '';
      return;
    }
    var cov  = coveragePct(vehicle.len, rec.rows);
    var gap  = coverageGapMM(vehicle.len, rec.rows);
    var kit  = KIT_VARIANTS[rec.rows];
    var tier = cov >= 90 ? 'good' : 'warn';

    $result.innerHTML =
      '<div class="cb-result__card">' +
        '<div class="cb-result__kit">' +
          '<p class="cb-result__eyebrow">Your recommended kit</p>' +
          '<h3>' + escapeHtml(kit.name) + ' — $' + kit.price.toFixed(2) + '</h3>' +
          '<p class="cb-result__detail">' + (rec.rows * 2) + ' Power Panels + ' + (rec.rows * 4) + ' Edge Strips + 4 Cargo Walls + 2 Caps + Patented QuickAccess Hinge™ + Pull Handle</p>' +
        '</div>' +
        '<div class="cb-result__stats">' +
          '<div class="cb-stat">' +
            '<div class="cb-stat__n cb-stat__n--' + tier + '">' + cov.toFixed(1) + '%</div>' +
            '<div class="cb-stat__l">Bed coverage</div>' +
          '</div>' +
          '<div class="cb-stat">' +
            '<div class="cb-stat__n">' + gap + ' mm</div>' +
            '<div class="cb-stat__l">Gravity Hinge Zone</div>' +
          '</div>' +
        '</div>' +
        '<p class="cb-result__zone">' +
          'The last <b>' + gap + ' mm at your tailgate</b> is the <b>Gravity Hinge Zone</b> — where your cargo lands when you pull the handle. Your bed is engaged from the cab to this zone.' +
        '</p>' +
      '</div>';

    $cta.innerHTML =
      '<form action="/cart/add" method="post">' +
        '<input type="hidden" name="id" value="' + kit.variantId + '">' +
        '<input type="hidden" name="quantity" value="1">' +
        '<button type="submit" class="cb-cta-btn">ADD ' + escapeHtml(kit.name.toUpperCase()) + ' TO CART — $' + kit.price.toFixed(2) + '</button>' +
      '</form>';

    /* Analytics (GA4 / gtag if present) */
    if (window.gtag) {
      try {
        window.gtag('event', 'fitment_recommendation_shown', {
          truck_brand: brand, truck_model: model, bed_size: bedVal,
          recommended_kit: kit.name, coverage_pct: Number(cov.toFixed(1))
        });
      } catch (e) {}
    }
  }

  /* WIRE UP */
  $type.addEventListener('change', function() { populateBrands(); });
  $brand.addEventListener('change', function() { populateModels(); });
  $model.addEventListener('change', function() { populateBeds(); });
  $bed.addEventListener('change', function() { renderResult(); });

  /* INITIALIZE — read URL params for Phase 2 microsite mode */
  var p = readUrlParams();
  if (p.type && ['truck','suv','van','sedan'].indexOf(p.type) !== -1) $type.value = p.type;
  populateBrands(p.brand || p.truck);
  if (p.brand || p.truck) {
    if ($brand.value) populateModels(p.model || p.truck);
    if ($model.value) populateBeds(p.bed);
  }
})();
